import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PixelButton, PixelText } from 'pixel-base'

const OtpGuardTest: React.FC = () => {
  const navigate = useNavigate()

  const checkAuthStatus = () => {
    const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}')
    return {
      isAuthenticated: Boolean(userInfo?.token),
      isOtpVerified: Boolean(userInfo?.is_otp_verified),
      userInfo,
    }
  }

  const simulateLogin = () => {
    const mockUserInfo = {
      token: 'mock-token-123',
      email: 'test@example.com',
      is_otp_verified: false,
    }
    localStorage.setItem('user_info', JSON.stringify(mockUserInfo))
    window.dispatchEvent(new Event('auth-change'))
    alert(
      'User logged in but OTP not verified. Try navigating to /orders - you should be redirected to OTP page.',
    )
  }

  const simulateOtpVerification = () => {
    const currentUserInfo = JSON.parse(
      localStorage.getItem('user_info') || '{}',
    )
    const updatedUserInfo = {
      ...currentUserInfo,
      is_otp_verified: true,
    }
    localStorage.setItem('user_info', JSON.stringify(updatedUserInfo))
    window.dispatchEvent(new Event('auth-change'))
    alert('OTP verified! You can now navigate to protected routes.')
  }

  const clearAuth = () => {
    localStorage.removeItem('user_info')
    window.dispatchEvent(new Event('auth-change'))
    alert('Auth cleared. You should be redirected to login.')
  }

  const status = checkAuthStatus()

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <PixelText textSize="24px" style={{ marginBottom: '20px' }}>
        OTP Guard Test Component
      </PixelText>

      <div
        style={{
          marginBottom: '20px',
          padding: '15px',
          border: '1px solid #ccc',
          borderRadius: '5px',
        }}
      >
        <PixelText textSize="16px" style={{ marginBottom: '10px' }}>
          Current Status:
        </PixelText>
        <div>Authenticated: {status.isAuthenticated ? 'Yes' : 'No'}</div>
        <div>OTP Verified: {status.isOtpVerified ? 'Yes' : 'No'}</div>
        <div>
          Menu Visible:{' '}
          {status.isAuthenticated && status.isOtpVerified ? 'Yes' : 'No'}
        </div>
        <div>User Info: {JSON.stringify(status.userInfo, null, 2)}</div>
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <PixelButton onClick={simulateLogin} variant="primary">
          Simulate Login (No OTP)
        </PixelButton>

        <PixelButton onClick={simulateOtpVerification} variant="primary">
          Simulate OTP Verification
        </PixelButton>

        <PixelButton onClick={clearAuth} variant="secondary">
          Clear Auth
        </PixelButton>

        <PixelButton onClick={() => navigate('/orders')} variant="primary">
          Try Navigate to Orders
        </PixelButton>

        <PixelButton
          onClick={() => navigate('/auth/login')}
          variant="secondary"
        >
          Go to Login Page
        </PixelButton>

        <PixelButton
          onClick={() => navigate('/auth/signup')}
          variant="secondary"
        >
          Go to Signup Page
        </PixelButton>
      </div>

      <div
        style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f5f5f5',
          borderRadius: '5px',
        }}
      >
        <PixelText textSize="14px" customColor="#666">
          Instructions:
        </PixelText>
        <ul style={{ marginTop: '10px' }}>
          <li>
            Click &quot;Simulate Login&quot; to create a user session without
            OTP verification
          </li>
          <li>
            Try navigating to /orders - you should be redirected to OTP page
          </li>
          <li>
            Click &quot;Simulate OTP Verification&quot; to mark OTP as verified
          </li>
          <li>Now you should be able to navigate to protected routes</li>
          <li>Click &quot;Clear Auth&quot; to log out</li>
          <li>
            <strong>Email Verification:</strong> On OTP page, users can go back
            to signup to verify/change email (when OTP not verified)
          </li>
        </ul>
      </div>
    </div>
  )
}

export default OtpGuardTest
